import {updatePropertyPreferences} from 'api/propertyPreferences';

export const UPDATE = 'pulp/filters/UPDATE';

export const initialState = {
  propertyTypes: [],
  radius: '2',
  withinMonths: '6',
  toggleWithinDate: false,
  toggleActiveListing: false,
  withinDateFrom: '',
  withinDateTo: '',
  landAreaMin: '',
  landAreaMax: '',
  priceMin: '',
  priceMax: '',
  beds: '',
  baths: '',
  carSpaces: '',
  targetSuburb: false,
  errors: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // case UPDATE:
    //   const dilutedValues = {
    //     beds: valueOrDefault(action.payload, 'beds', initialState.beds, state.beds),
    //     baths: valueOrDefault(action.payload, 'baths', initialState.baths, state.baths),
    //     carSpaces: valueOrDefault(action.payload, 'carSpaces', initialState.carSpaces, state.carSpaces),
    //   };
    //   return {
    //     ...state,
    //     ...action.payload,
    //     ...dilutedValues,
    //   };
    default:
      return state;
  }
}

export const updateFilters = function (payload, updatePrefs = false) {
  return (dispatch, getState) => {
    const {
      propertyDetail: {propertyId},
      filters,
    } = getState();

    if (updatePrefs) {
      updatePropertyPreferences(propertyId, {filters: {...filters, ...payload}});
    }

    dispatch({type: UPDATE, payload});
  };
};
